import {ClockCircleOutlined, LoginOutlined, LogoutOutlined} from '@ant-design/icons';
import {Col, Row} from 'antd';
import {Header} from "antd/lib/layout/layout";
import {User} from "oidc-react";
import React, {useEffect, useState} from 'react';
import styles from './headerComponent.module.less';
import {AsyncButton} from "digimuth-components/dist";

interface HeaderComponentProps {
    onLogoutPressed: () => Promise<any>,
    onLoginPressed: () => Promise<any>,
    userData?: User | null;
}

export default function HeaderComponent(props: HeaderComponentProps) {
    const [currentDateTime, setCurrentDateTime] = useState(() => new Date());

    useEffect(() => {
        const timer = window.setInterval(() => setCurrentDateTime(new Date()), 1000);
        return () => window.clearInterval(timer);
    }, []);

    const isTestEnvironment = ["localhost", "127.0.0.1", "::1"]
        .includes(window.location.hostname.toLowerCase());
    const environmentLabel = isTestEnvironment
        ? <div className={styles.environmentLabel}>Środowisko testowe</div>
        : null;
    const dateTime = <div className={styles.dateTime} title="Aktualna data i godzina">
        <ClockCircleOutlined/>
        <span className={styles.date}>
            {currentDateTime.toLocaleDateString("pl-PL", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric"
            })}
        </span>
        <strong>{currentDateTime.toLocaleTimeString("pl-PL")}</strong>
    </div>;

    if (props.userData) {
        return <Header className={styles.exHeader}>
            {environmentLabel}
            <Row align="middle" justify="end" wrap={false} className={styles.headerContent}>
                <Col flex="none">{dateTime}</Col>
                <Col flex="auto" className={styles.userNameWrapper}>
                    <span>{props.userData.profile.email}</span>
                </Col>
                <Col flex="none">
                    <AsyncButton
                        type="text"
                        onClick={props.onLogoutPressed}
                        icon={<LogoutOutlined/>}
                    >
                        Wyloguj
                    </AsyncButton>
                </Col>
            </Row>
        </Header>;
    }

    return <Header className={styles.exHeader}>
        {environmentLabel}
        <Row align="middle" wrap={false} className={styles.headerContent}>
            <Col flex="none">{dateTime}</Col>
            <Col flex="auto"/>
            <Col flex="none">
                <AsyncButton type="text" onClick={props.onLoginPressed} icon={<LoginOutlined/>}>Zaloguj</AsyncButton>
            </Col>
        </Row>
    </Header>;
}
